import { render, staticRenderFns } from "./ViewPdi.vue?vue&type=template&id=627cebaf&scoped=true"
import script from "./ViewPdi.vue?vue&type=script&lang=js"
export * from "./ViewPdi.vue?vue&type=script&lang=js"
import style0 from "./ViewPdi.vue?vue&type=style&index=0&id=627cebaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cebaf",
  null
  
)

export default component.exports